import { motion } from "framer-motion";

/**
 * ProcessTimeline — vertical fuel-pathway timeline with milestone nodes.
 * Line draws in on scroll; nodes pulse. `highlightIndex` marks the "active" node.
 */
export const ProcessTimeline = ({ steps = [], highlightIndex = -1, testid = "process-timeline" }) => (
  <div className="relative mx-auto max-w-3xl" data-testid={testid}>
    {/* the pathway rail */}
    <div className="absolute left-[19px] top-2 bottom-2 w-px bg-white/10 md:left-[27px]" aria-hidden="true">
      <motion.div
        className="w-px origin-top bg-gradient-to-b from-ff-ember via-ff-ember to-ff-teal"
        initial={{ scaleY: 0 }}
        whileInView={{ scaleY: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1.6, ease: "easeInOut" }}
        style={{ height: "100%" }}
      />
    </div>

    <ol className="space-y-8">
      {steps.map((s, i) => {
        const active = i === highlightIndex;
        return (
          <motion.li
            key={s.step}
            className="relative flex gap-5 md:gap-7"
            initial={{ opacity: 0, x: -16 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
          >
            {/* node */}
            <div className="relative z-10 flex-shrink-0">
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-full border font-mono text-xs font-bold md:h-14 md:w-14 md:text-sm ${
                  active
                    ? "border-ff-ember bg-ff-ember text-ff-midnight shadow-[0_0_20px_rgba(255,75,34,0.5)]"
                    : "border-white/15 bg-ff-slate text-ff-grey"
                }`}
              >
                {s.step}
              </div>
              {active && (
                <span className="absolute inset-0 -z-10 animate-pulse-glow rounded-full bg-ff-ember/40 blur-lg" />
              )}
            </div>

            {/* content */}
            <div className="flex-1 rounded-2xl border border-white/5 bg-ff-slate/50 p-5 backdrop-blur-sm md:p-6">
              <h3 className="font-display text-lg font-semibold text-ff-ivory md:text-xl">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ff-grey md:text-base">{s.body}</p>
            </div>
          </motion.li>
        );
      })}
    </ol>
  </div>
);

export default ProcessTimeline;
